import { IAppState } from '../../common/state';

export const getIsNeedSelfEmployedConfirmation = (state: IAppState) =>
  !!state.results?.newbuildingBroker?.isNeedSelfEmployedConfirmation;
